import React, { useState } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import style from './style/Signupstyle.module.css';
import api from '../apis/api';
// import Loader from '../components/Loader';
import CardLoader from '../components/CardLoader';

const Login = () => {
    const history = useHistory();
    const [user,setUser] = useState({email:'',password:''});
    const [message,updateMessage] = useState('');
    const [loader,setLoader] = useState(true);

    const HandelSubmit = async (e) => {
        e.preventDefault();
        setLoader(false);

        try {
            const response = await api.post('/login',{
                email:user.email,password:user.password
            });

            const data = await response.data;
            setLoader(true);
            updateMessage(data.msg);
            document.getElementById('msg').style.color='green';
            setUser({email:'',password:''});
            history.push('/products');

        } catch (error) {
            let err = error.response.data;
            setLoader(true);
            updateMessage(err.msg)
        }

    }

    return (
        <>
            <section className={style.body}>
                <div className={style.form} style={{ margin: '40px auto' }}>
                    <h1 style={{ textAlign: 'center' }}>Login !!!</h1>
                    <p id="msg" style={{ textAlign: 'center', color:'red' }}>{message}</p>
                    {loader?
                    <form>
                        <div className={style.formlabel}>
                            <label htmlFor="email">Email<sup>*</sup></label><br />
                            <input type="email" name="email" placeholder='Enter your registered email' value={user.email} onChange={(e)=>setUser({...user,email:e.target.value})} />
                        </div>
                        <div className={style.formlabel}>
                            <label htmlFor="password">Password<sup>*</sup></label><br />
                            <input type="password" name="password" placeholder='Enter your password' value={user.password} onChange={(e)=>setUser({...user,password:e.target.value})} />
                        </div>
                        <button type="submit" onClick={HandelSubmit} >Login</button>
                        <div style={{ float: 'right', marginTop: '15px' }}>
                            <p>Don't Have an Account?</p>
                            <NavLink to='/signup'>Create Here</NavLink>
                        </div>
                    </form>
                    :<CardLoader/>}
                </div>
            </section>
        </>
    )
}

export default Login;
